<template>
  <section class="pipe">
    <div class="pipe__head">
      <h2 class="pipe__title">Pipeline</h2>
      <span v-if="total" class="pipe__sub">{{ total }} abierta{{ total === 1 ? "" : "s" }}</span>
    </div>

    <div v-if="total" class="pipe__list">
      <div v-for="s in stages" :key="s.label" class="pipe__row">
        <span class="pipe__name">{{ stateLabel(s.label) }}</span>
        <span class="pipe__track">
          <span class="pipe__fill" :class="'pipe__fill--' + s.label" :style="{ width: pct(s.count) + '%' }"></span>
        </span>
        <span class="pipe__count">{{ s.count }}</span>
      </div>
    </div>
    <div v-else class="pipe__empty">Sin consultas abiertas en el pipeline.</div>
  </section>
</template>

<script>
import { STATE_LABELS } from "@/utils/funnel";

export default {
  props: {
    pipeline: { type: Array, default: () => [] }
  },
  computed: {
    stages() {
      return this.pipeline || [];
    },
    total() {
      return this.stages.reduce((a, s) => a + (s.count || 0), 0);
    },
    max() {
      return Math.max(1, ...this.stages.map(s => s.count || 0));
    }
  },
  methods: {
    stateLabel(s) {
      return STATE_LABELS[s] || s;
    },
    // bar length relative to the busiest stage (clear even when one stage dominates)
    pct(n) {
      if (!n) return 0;
      return Math.max(4, Math.round((n / this.max) * 100));
    }
  }
};
</script>

<style scoped>
.pipe { background: #fff; border: 1px solid #ece7de; border-radius: 14px; padding: 18px 20px; box-shadow: 0 8px 24px -16px rgba(40, 33, 22, 0.18); margin-bottom: 22px; }
.pipe__head { display: flex; align-items: baseline; gap: 10px; margin-bottom: 14px; }
.pipe__title { font-size: 16px; font-weight: 700; color: #1a1814; margin: 0; }
.pipe__sub { font-size: 12px; color: #a39a8c; }

.pipe__list { display: flex; flex-direction: column; gap: 11px; }
.pipe__row { display: grid; grid-template-columns: max-content 1fr 32px; align-items: center; gap: 12px; }
.pipe__name { font-size: 13px; font-weight: 600; color: #1a1814; white-space: nowrap; }
.pipe__track { height: 8px; border-radius: 999px; background: #f1ece3; overflow: hidden; }
.pipe__fill { display: block; height: 100%; border-radius: 999px; }
.pipe__fill--pending { background: #e0892f; }
.pipe__fill--ongoing { background: #2353b8; }
.pipe__fill--on_hold { background: #6a3a8f; }
.pipe__fill--watching { background: #6a3a8f; }
.pipe__fill--visit { background: #0e7490; }
.pipe__fill--negotiation { background: #b45309; }
.pipe__count { font-size: 13px; font-weight: 700; color: #1a1814; text-align: right; }

.pipe__empty { color: #a39a8c; font-size: 13.5px; padding: 6px 0; }
</style>
